import type {ReactElement} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import {Text, TextSize} from '@Components/text';
import {dispatchRevealInvalidLink} from '@EmailMakerReact/lib/email-maker-selection-library';
import type {SaveErrorDetailProps} from '../../email-maker-save-error-popup.types';
import styles from './invalid-links-save-error-detail.module.scss';

/** Custom detail for INVALID_CAMPAIGN_URLS: heading + clickable list of bad link URLs that reveal their text component on the canvas. */
export function InvalidLinksSaveErrorDetail({saveError, onClose}: SaveErrorDetailProps): ReactElement {
  return (
    <>
      <Text val={window.i18next.t('pmwjs_fix_invalid_links_to_save')} size={TextSize.MD} bold className="ct-neutral-primary" />
      <ul className={styles.list}>{(saveError.invalidUrls ?? []).map((url) => renderInvalidUrlItem(url, onClose))}</ul>
    </>
  );
}

function renderInvalidUrlItem(url: string, onClose: () => void): ReactElement {
  function handleInvalidUrlClick(): void {
    dispatchRevealInvalidLink(url);
    onClose();
  }

  return (
    <li key={url} className={styles.listItem}>
      <ClickableDiv className={styles.invalidLinkRow} onClick={handleInvalidUrlClick}>
        <Text val={url} size={TextSize.MD} className="ct-error-primary" />
      </ClickableDiv>
    </li>
  );
}
